import React from 'react';
import useAppStore from '../../store/appStore';

export default function ReasoningChain() {
  const chain = useAppStore(s => s.lastReasoningChain);
  const selectedAtom = useAppStore(s => s.selectedAtom);
  const setSelectedAtom = useAppStore(s => s.setSelectedAtom);

  return (
    <div className="reasoning-chain-panel">
      {/* Selected atom detail */}
      {selectedAtom && (
        <div className="atom-detail">
          <div className="panel-header">
            <h3>Atom Detail</h3>
            <button className="close-btn" onClick={() => setSelectedAtom(null)}>×</button>
          </div>
          <AtomDetail atom={selectedAtom} />
        </div>
      )}

      {/* Last reasoning chain — F-11 */}
      {chain && chain.length > 0 && (
        <div className="chain-section">
          <div className="panel-section-title">Last Reasoning Chain</div>
          <div className="chain-steps">
            {chain.map((step, i) => (
              <div key={i} className="chain-step-row">
                <div className="step-connector">
                  {i < chain.length - 1 && <div className="step-line" />}
                  <div className={`step-dot ${i === 0 ? 'step-dot-start' : i === chain.length - 1 ? 'step-dot-end' : ''}`} />
                </div>
                <div className="step-text">{step}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {!selectedAtom && (!chain || chain.length === 0) && (
        <div className="empty-state">
          <p>Reasoning chain appears here after each query.</p>
          <p>Click any node in the graph to inspect it.</p>
        </div>
      )}
    </div>
  );
}

function AtomDetail({ atom }) {
  const tv = atom.truth_value || {};
  const meta = atom.metadata || {};

  return (
    <div className="atom-detail-body">
      <div className="atom-field">
        <span className="field-label">Type</span>
        <span className="field-value type-tag">{atom.type}</span>
      </div>
      <div className="atom-field">
        <span className="field-label">Name</span>
        <span className="field-value">{atom.name}</span>
      </div>
      <div className="atom-field">
        <span className="field-label">Domain</span>
        <span className="field-value domain-tag">{atom.domain}</span>
      </div>
      {tv.strength !== undefined && (
        <div className="atom-field">
          <span className="field-label">Truth Value</span>
          <span className="field-value">
            s={tv.strength?.toFixed(2)} / c={tv.confidence?.toFixed(2)}
          </span>
        </div>
      )}
      <div className="atom-field">
        <span className="field-label">Source</span>
        <span className="field-value">{atom.source || '—'}</span>
      </div>
      {Object.keys(meta).length > 0 && (
        <div className="atom-field atom-meta-field">
          <span className="field-label">Metadata</span>
          <pre className="field-value meta-json">{JSON.stringify(meta, null, 2)}</pre>
        </div>
      )}
      {atom.timestamp && (
        <div className="atom-field">
          <span className="field-label">Stored</span>
          <span className="field-value">{new Date(atom.timestamp).toLocaleString()}</span>
        </div>
      )}
    </div>
  );
}
